import * as Yup from 'yup';

const shape = {
	id: Yup.number().required().positive().integer().default(0),
	firstname: Yup.string().default('').required('Required'),
	lastname: Yup.string().default('').required('Required'),
	phone: Yup.string()
		.min(10)
		.max(10)
		.matches(/^\d+$/, 'Phone number is not valid')
		.default('')
		.transform((value, originalValue) => (originalValue === null ? undefined : value)),
	email: Yup.string().email('Invalid email').default(''),
	roleId: Yup.number().required('Required').positive().integer().default(0),
	showSupplierDropDown: Yup.boolean().default(false),
	supplierId: Yup.number().when('showSupplierDropDown', {
		is: true,
		// biome-ignore lint/suspicious/noThenProperty: <explanation>
		then: (schema) => schema.required('Required'),
		otherwise: (schema) => schema.notRequired(),
	}),
	company: Yup.string().default('').required('Required'),
};

export interface UserProps {
	id: number;
	firstname: string;
	lastname: string;
	phone: string;
	email: string;
	roleId: number;
	showSupplierDropDown: boolean;
	supplierId?: number;
	company: string;
	roles?: {
		id: number;
		role: string;
	}[];
}

export interface RoleProps {
	id: number;
	role: string;
}

export interface OrderByProps {
	id: number;
	firstname: string;
	lastname: string;
	phone: string;
	email: string;
	company: string;
}

const normalizeForUpdate = (user: UserProps) => {
	return {
		id: user.id,
		firstname: user.firstname,
		lastname: user.lastname,
		phone: user.phone,
		company: user.company,
		supplierId: user.supplierId,
		roles: [
			{
				id: user.roleId,
			},
		],
	};
};

export const User = {
	schema: Yup.object()
		.shape(shape)
		.transform((value) => {
			// infer roleId from roles field
			if ('roles' in value) {
				const res = {} as UserProps;

				// biome-ignore lint/complexity/noForEach: <explanation>
				Object.keys(shape).forEach((field) => {
					if (field === 'showSupplierDropDown') {
						res[field] = !!value.supplierId;
					} else {
						// @ts-ignore
						res[field] = field === 'roleId' ? value.roles?.[0]?.id : value[field];
					}
				});

				return res;
			}

			return value;
		}),
	normalizeForUpdate,
};
